module.exports = __webpack_public_path__ + "static/img/10.65c2d24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/cards/zombs/10.png
// module id = bihU
// module chunks = 35